import { useLang } from "@/lib/i18n";

export function LangToggle() {
  const { lang, toggle } = useLang();
  return (
    <button
      onClick={toggle}
      aria-label={lang === "en" ? "Switch to Hindi" : "Switch to English"}
      data-testid="lang-toggle"
      title={lang === "en" ? "हिंदी में देखें" : "View in English"}
      className="h-10 px-3 grid place-items-center border border-border hover:border-foreground transition-colors label-overline text-[10px] whitespace-nowrap"
    >
      <span className="flex items-center gap-1.5">
        <span className={lang === "en" ? "text-foreground" : "text-muted-foreground"}>EN</span>
        <span className="text-muted-foreground">/</span>
        <span className={lang === "hi" ? "text-foreground font-hindi" : "text-muted-foreground font-hindi"}>हि</span>
      </span>
    </button>
  );
}
